class LoginFlowPresenter {
    constructor(usecase, actions) {
        this.usecase = usecase;
        this.actions = actions;
        this.resetLoginState = false;
    }
    updateResetLoginState(resetLoginState) {
        this.resetLoginState = resetLoginState;
    }
    getReturnLoginState() {
        return this.resetLoginState;
    }
    getUnblockUserDetails(req) {
        this.actions.unblockUser.hideError();
        this.actions.unblockUser.loader();
        this.usecase.unblockUser.execute({
            onSuccess: (data) => {
                if (data) {
                    this.actions.unblockUser.unblockUser({
                        success: data.success,
                        userID: req.userId,
                    });
                }
                this.actions.unblockUser.stopLoader();
            },
            onError: (error) => {
                this.actions.unblockUser.setError({ isOpen: true, error });
                this.actions.unblockUser.stopLoader();
            },
        }, req);
    }
    flushLoginError() {
        this.updateResetLoginState(false);
        this.actions.clientLoginDataActions.hideError();
        this.actions.guestRegisterActions.hideError();
        this.actions.clientGenOTP.hideError();
        this.actions.guestValidateMPIN.hideError();
        this.actions.clientValPass.hideError();
        this.actions.getAccountDetails.hideError();
        this.actions.clientForgotUserID.hideError();
        this.actions.unblockUser.hideError();
        this.actions.clientSetPass.hideError();
        this.actions.clientValOTP.hideError();
        this.actions.guestRegEmailVerifyOTP.hideError();
    }
    flushLoginReducers() {
        this.actions.clientSetPass.ClientSetPassword({});
    }
    updateLoginData(data) {
        this.actions.clientLoginDataActions.getLoginData({
            jwtToken: data === null || data === void 0 ? void 0 : data.jwtToken,
            accTyp: data === null || data === void 0 ? void 0 : data.accTyp,
            userID: data === null || data === void 0 ? void 0 : data.userID,
            emaildId: data === null || data === void 0 ? void 0 : data.emaildId,
            accountCode: data === null || data === void 0 ? void 0 : data.accountCode,
            lgnSrc: data === null || data === void 0 ? void 0 : data.lgnSrc,
            isImpersonated: data === null || data === void 0 ? void 0 : data.isImpersonated,
            //
            registeredGuestAccount: data === null || data === void 0 ? void 0 : data.registeredGuestAccount,
            clientAccount: data === null || data === void 0 ? void 0 : data.clientAccount,
            accValDays: data === null || data === void 0 ? void 0 : data.accValDays,
            name: data === null || data === void 0 ? void 0 : data.name,
            mobile: data === null || data === void 0 ? void 0 : data.mobile,
            status: data === null || data === void 0 ? void 0 : data.status,
            message: data === null || data === void 0 ? void 0 : data.message,
            registeredDate: data === null || data === void 0 ? void 0 : data.registeredDate,
            pan: data === null || data === void 0 ? void 0 : data.pan,
            accountTypesArray: data === null || data === void 0 ? void 0 : data.accountTypesArray,
            vendorSource: data === null || data === void 0 ? void 0 : data.vendorSource,
            isOtpSucesss: data === null || data === void 0 ? void 0 : data.isOtpSucesss,
            loginFlow: data === null || data === void 0 ? void 0 : data.loginFlow,
            passwordReset: data === null || data === void 0 ? void 0 : data.passwordReset,
            daysLeft: data === null || data === void 0 ? void 0 : data.daysLeft,
        });
    }
    flushLoginData() {
        this.actions.clientLoginDataActions.getLoginData({
            jwtToken: "",
            accTyp: "",
            userID: "",
            emaildId: "",
            accountCode: "",
            lgnSrc: "",
            isImpersonated: false,
            //
            registeredGuestAccount: false,
            clientAccount: false,
            accValDays: 0,
            name: "",
            mobile: "",
            status: "",
            message: "",
            registeredDate: "",
            accountTypesArray: [],
            vendorSource: "",
            isOtpSucesss: false,
            loginFlow: "",
            passwordReset: false,
        });
        this.actions.clientValPass.ClientValPassword({
            isOtpSucesss: false,
            loginFlow: "",
            message: "",
            status: false,
        });
    }
    getImage(req) {
        this.actions.clientLoginDataActions.hideError();
        this.actions.clientLoginDataActions.loader();
        this.usecase.imageClientLoginFlow.execute({
            onSuccess: (data) => {
                this.flushLoginData();
                this.updateLoginData({
                    userID: req.userId,
                    accountTypesArray: data.accountTypesArray,
                    message: data.message,
                    status: data.status,
                    vendorSource: data.vendorSource,
                });
                this.actions.clientLoginDataActions.stopLoader();
            },
            onError: (error) => {
                this.actions.clientLoginDataActions.setError({ isOpen: true, error });
                this.actions.clientLoginDataActions.stopLoader();
            },
        }, req);
    }
    getQuestionsData(req) {
        this.actions.clientValPass.hideError();
        this.actions.clientValPass.loader();
        this.usecase.clientLoginFlowQuestion.execute({
            onSuccess: (data) => {
                if (data) {
                    this.actions.clientValPass.ClientValPassword(data);
                }
                this.actions.clientValPass.stopLoader();
            },
            onError: (error) => {
                this.actions.clientValPass.setError({ isOpen: true, error });
                this.actions.clientValPass.stopLoader();
            },
        }, req);
    }
    updateLoginPopup(loginPopup) {
        this.actions.clientValOTP.setShowLoginPopup(loginPopup);
    }
    getLoginData(req) {
        this.actions.clientValOTP.hideError();
        this.actions.clientValOTP.loader();
        this.usecase.clientLoginData.execute({
            onSuccess: (data) => {
                var _a, _b;
                this.actions.clientValOTP.clientValidateOTP(data);
                this.actions.updateAccountDetails.updateAccountDetails({
                    accTyp: data.accData.accType,
                    userID: data.userID || data.accData.userId,
                    emaildId: data.emaildId,
                    accountCode: data.accountCode,
                    lgnSrc: data.lgnSrc,
                    isImpersonated: data.isImpersonated,
                    empOrDependent: (_b = (_a = data === null || data === void 0 ? void 0 : data.accData) === null || _a === void 0 ? void 0 : _a.accs) === null || _b === void 0 ? void 0 : _b.empOrDependent,
                });
                localStorage.setItem("acc_data", JSON.stringify(data.accData));
                this.actions.clientValOTP.stopLoader();
            },
            onError: (error) => {
                this.actions.clientValOTP.setError({ isOpen: true, error });
                this.actions.clientValOTP.stopLoader();
            },
        }, req);
    }
    guestRegister(req) {
        return new Promise((resolve, reject) => {
            this.usecase.guestRegisterAddAccount.execute({
                onSuccess: (data) => {
                    resolve(data);
                },
                onError: (error) => {
                    reject(error);
                },
            }, req);
        });
    }
    clientSetPassword(req) {
        this.actions.clientSetPass.hideError();
        this.actions.clientSetPass.loader();
        this.usecase.clientSetPassword.execute({
            onSuccess: (data) => {
                if (data) {
                    this.actions.clientSetPass.ClientSetPassword(data);
                }
                this.actions.clientSetPass.stopLoader();
            },
            onError: (error) => {
                this.actions.clientSetPass.setError({ isOpen: true, error });
                this.actions.clientSetPass.stopLoader();
            },
        }, req);
    }
    async clientValidateOTP(req) {
        let response = null;
        await this.usecase.clientValidateOTP.execute({
            onSuccess: (data) => {
                response = data;
            },
            onError: (error) => { },
        }, req);
        return response;
    }
    clientGenerateOTP(req) {
        this.actions.clientGenOTP.hideError();
        this.actions.clientGenOTP.loader();
        this.usecase.clientGenerateOTP.execute({
            onSuccess: (data) => {
                this.actions.clientGenOTP.ClientGenOTP(data);
                this.actions.clientGenOTP.stopLoader();
            },
            onError: (error) => {
                this.actions.clientGenOTP.setError({ isOpen: true, error });
                this.actions.clientGenOTP.stopLoader();
            },
        }, req);
    }
    clientForgotUserID(req) {
        this.actions.clientForgotUserID.hideError();
        this.actions.clientForgotUserID.loader();
        this.usecase.clientForgotUserID.execute({
            onSuccess: (data) => {
                this.actions.clientForgotUserID.forgotUserID(data);
                this.actions.clientForgotUserID.stopLoader();
            },
            onError: (error) => {
                this.actions.clientForgotUserID.setError({ isOpen: true, error });
                this.actions.clientForgotUserID.stopLoader();
            },
        }, req);
    }
    getAccountDetails(req) {
        this.actions.getAccountDetails.hideError();
        this.actions.getAccountDetails.getAccountDetailloader();
        this.usecase.getAccountDetails.execute({
            onSuccess: (data) => {
                if (data) {
                    this.actions.getAccountDetails.getAccountDetails({
                        registeredGuestAccount: data.registeredGuestAccount,
                        clientAccount: data.clientAccount,
                        status: data.status,
                        guestId: data.guestId,
                        mobile: req.mob,
                    });
                }
                this.actions.getAccountDetails.getAccountDetailStopLoader();
            },
            onError: (error) => {
                this.actions.getAccountDetails.setError({ isOpen: true, error });
                this.actions.getAccountDetails.getAccountDetailStopLoader();
            },
        }, req);
    }
    async guestLoginSetMPIN(req) {
        return new Promise((resolve, reject) => {
            this.usecase.guestLoginSetMpin.execute({
                onSuccess: (data) => {
                    resolve(data);
                },
                onError: (error) => {
                    reject(error);
                },
            }, req);
        });
    }
    GuestValidateMPIN(req) {
        this.actions.guestValidateMPIN.hideError();
        this.actions.guestValidateMPIN.GuestValidateMPINloader();
        this.usecase.guestValidateMPIN.execute({
            onSuccess: (data) => {
                if (data) {
                    this.actions.guestValidateMPIN.GuestValidateMPIN(data);
                    localStorage.setItem("guest_acc_data", JSON.stringify(data));
                }
                this.actions.guestValidateMPIN.GuestValidateMPINStopLoader();
            },
            onError: (error) => {
                this.actions.guestValidateMPIN.setError({ isOpen: true, error });
                this.actions.guestValidateMPIN.GuestValidateMPINStopLoader();
            },
        }, req);
    }
    async guestForgotPIN(req) {
        let response = null;
        await this.usecase.guestForgotPIN.execute({
            onSuccess: (data) => {
                response = data;
            },
            onError: (error) => { },
        }, req);
        return response;
    }
    guestRegValidateOTP(req) {
        this.actions.guestRegisterActions.hideError();
        this.actions.guestRegisterActions.loader();
        this.usecase.guestValidate.execute({
            onSuccess: (data) => {
                this.actions.guestRegisterActions.guestRegister(data);
                this.actions.guestRegisterActions.stopLoader();
            },
            onError: (error) => {
                this.actions.guestRegisterActions.setError({ isOpen: true, error });
                this.actions.guestRegisterActions.stopLoader();
            },
        }, req);
    }
    async checkNAddEmail(req) {
        let response = null;
        await this.usecase.checkNAddEmailUseCase.execute({
            onSuccess: (data) => {
                response = data;
            },
            onError: (error) => {
                response = {
                    message: error.getErrorMessageOrErrMsg(),
                    status: false,
                };
            },
        }, req);
        return response;
    }
    guestRegEmailVerifyOTP(req) {
        this.actions.guestRegEmailVerifyOTP.hideError();
        this.actions.guestRegEmailVerifyOTP.loader();
        this.usecase.guestRegEmailVerifyOTP.execute({
            onSuccess: (data) => {
                this.actions.guestRegEmailVerifyOTP.GuestVerifyEmailOTP({
                    message: data.message,
                    uniqueID: req.unId,
                    emailOTPValidated: data.emailOTPValidated,
                    isClient: data.isClient,
                    isGuest: data.isGuest,
                });
                this.actions.guestRegEmailVerifyOTP.stopLoader();
            },
            onError: (error) => {
                this.actions.guestRegEmailVerifyOTP.setError({ isOpen: true, error });
                this.actions.guestRegEmailVerifyOTP.stopLoader();
            },
        }, req);
    }
}
export default LoginFlowPresenter;
